// extracted by mini-css-extract-plugin
module.exports = {"closed":"styles_closed__6nwSZ","batched":"styles_batched__mm0RY","expanded":"styles_expanded__56nDj"};